import { Services } from 'types/Services'
import { Order, PlusLoadStatus } from 'types/Order'
import { Dispatch } from 'redux'
import { createActionOpenPlusLoadModal } from 'State/Store/PlusLoadModal/PlusLoadModalActionCreatorsMapping'
import { PlusLoadExceptionModalAction } from 'State/Store/PlusLoadExceptionModal/PlusLoadExceptionModal.reducer'
import { IsTooLateForPlusLoadServiceResult } from 'Services/Order/services/is-too-late-for-plus-load'

interface Args {
  services: Services,
  order: Order,
  dispatch: Dispatch<any>,
}
export const checkThenOpenPlusLoadModal = async (args: Args) => {
  const {
    services,
    order,
    dispatch,
  } = args
  const { status } = order.details.plusLoadDetails
  if ([PlusLoadStatus.SUBMITTED, PlusLoadStatus.APPLIED].includes(status)) {
    dispatch(PlusLoadExceptionModalAction.openPlusLoadSubmittedOrApplied())
    return
  }
  try {
    const result: IsTooLateForPlusLoadServiceResult = await services.orderService.isTooLateForPlusLoad({ orderKey: order.orderKey })
    if (result && !result.isToLateForPlusLoad) {
      dispatch(createActionOpenPlusLoadModal())
    } else {
      dispatch(PlusLoadExceptionModalAction.openTooLate())
    }
  } catch (e) {
    //
  }
}
